import { ButtonLink, Stack, StackItem } from '@asgard/ui-library';

import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { CardHighlight03 } from 'components/CardHighlight03/CardHighlight03';
import { HashAnchor } from 'components/HashAnchor';
import { PageContentContainer } from 'components/layout/Page.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import Link from 'next/link';
import { getPublicPath } from 'utils/paths';
import { TalentIntro } from '../components/intro/TalentIntro';
import { TalentCVStyles } from './TalentCV.styles';

export const TalentCV: React.FC = () => {
  const { t } = useI18n('talent-new');

  return (
    <TalentCVStyles.Root>
      <Stack direction="column" gap="4xl">
        <PageContentContainer containerSize="xl">
          <TalentIntro
            className="intro"
            title={t('talent-new.cv.title')}
            desc={t('talent-new.cv.desc')}
          />

          <Stack direction="column" gap="4xl">
            <HashAnchor name="professional_profile" />
            <CardHighlight03>
              <TalentCVStyles.CardContent1>
                <img
                  loading="lazy"
                  src={getPublicPath(
                    `/images/talent-new/talent-new-features-feature1.webp`
                  )}
                  alt=""
                />

                <StackItem>
                  <h3>{t(`talent-new.cv.feature1.card-title`)}</h3>
                  <HtmlTrans
                    ns="talent-new"
                    i18nKey={`talent-new.cv.feature1.card-content`}
                  />

                  <Link
                    href={
                      'https://www.getmanfred.com/blog/como-hacer-un-perfil-perfecto-en-manfred'
                    }
                    passHref
                  >
                    <ButtonLink
                      schema="brand1"
                      variant="hard"
                      endIcon={faArrowRight}
                      size="s"
                      label={t('talent-new.cv.feature1.cta')}
                    />
                  </Link>
                </StackItem>
              </TalentCVStyles.CardContent1>
            </CardHighlight03>

            <CardHighlight03>
              <TalentCVStyles.CardContent1>
                <img
                  loading="lazy"
                  src={getPublicPath(
                    `/images/talent-new/talent-new-features-feature2.webp`
                  )}
                  alt=""
                />

                <StackItem>
                  <h3>{t(`talent-new.cv.feature2.card-title`)}</h3>
                  <HtmlTrans
                    ns="talent-new"
                    i18nKey={`talent-new.cv.feature2.card-content`}
                  />

                  <Link
                    href={
                      'https://www.getmanfred.com/blog/importar-tus-datos-de-linkedin'
                    }
                    passHref
                  >
                    <ButtonLink
                      schema="brand1"
                      variant="hard"
                      endIcon={faArrowRight}
                      size="s"
                      label={t('talent-new.cv.feature2.cta')}
                    />
                  </Link>
                </StackItem>
              </TalentCVStyles.CardContent1>
            </CardHighlight03>
          </Stack>
        </PageContentContainer>
      </Stack>
    </TalentCVStyles.Root>
  );
};

export default TalentCV;
